export default __webpack_public_path__ + "static/26-6ab3ebf4d9e5c75a61483486449cfa54.png";